import useRemove from "@/hooks/use-remove";
import { UseLoadingReturn } from "@/hooks/use-loading";
import serviceHoursService from "@/services/service-hours.service";
import { RequestsProps } from "@/types/requests.types";

export type Props = {
  _id: number;
} & RequestsProps;

export type Return = {
  remove: (props: Props) => Promise<void>;
} & UseLoadingReturn;

const useRemoveServiceHours = (): Return => {
  const { isLoading, startLoading, endLoading, loadingIcon, remove } = useRemove({
    operation: (_id) => serviceHoursService.delete(_id),
  });

  return { isLoading, startLoading, endLoading, loadingIcon, remove };
};

export default useRemoveServiceHours;
